














import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import Icon from '../../src/components/Icon.vue';

@Component({
  components: {Icon}
})
export default class Input extends Vue {
  @Prop(String) value?: string;
  @Prop({default: false}) disabled?: boolean;
  @Prop({default: false}) readonly?: boolean;
  @Prop(String) error?: string;
}
